module.exports = __webpack_public_path__ + "static/img/6bg_10.701b45f.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/6bg_10.png
// module id = 736
// module chunks = 1